<template>
  <div class="goods-menu">
    <div class="activity_area">原材料集中采购专区</div>
    <div class="activity">
      <template v-if="list.length">
        <div
          class="card-container"
          @click.stop="jumpDetail(item.promotionSkuId)"
          v-for="item in list"
          :key="item.id"
        >
          <div class="imgSrc">
            <el-image 
              :src="item.image"
              fit="cover"
            />
          </div>
          <div class="goods-amount">
            <div class="sale_price">
              <template v-if="item.priceType == 1">
                <span v-if="item.promotionPrice == 0">
                  {{ showPrice0 }}
                </span>
                <span v-else
                  >￥{{ format_with_array(item.promotionPrice) }}</span
                >
              </template>
              <template v-else>
                <span :title="item.promotionPrice">{{ item.promotionPrice }}</span>
              </template>
            </div>
          </div>
          <div class="origin_price">
            <template v-if="item.skuPriceType == 1">
              <span v-if="item.price == 0">
                {{ showPrice0 }}
              </span>
              <span v-else>￥{{ format_with_array(item.price) }}</span>
            </template>
            <template v-else>
              <span :title="item.price">{{ item.price }}</span>
            </template>
          </div>
          <div class="goods-name">
            {{ item.productName || "_" }}
          </div>
          <div class="stock">
            活动库存：{{ item.promotionQuantity }} {{ item.unit }}
          </div>
          <template>
            <div v-if="getComputed(item) == '长期'" style="color: #e60012">
              长期有效
            </div>
            <div
              v-else-if="getComputed(item) == '已结束'"
              style="color: #e60012"
            >
              活动已结束
            </div>
            <CountDown
              v-else
              :targetDate="getCertainTime(item)"
              :isBegin="isBegin(item.promotionStartTime)"
              @updateActivityList="refreshPromotionList"
            ></CountDown>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="activity_over">
          <img src="@/assets/images/activity_banner.png" alt="" srcset="" />
        </div>
      </template>
      <div class="empty" v-for="(it, idx) in suppleList" :key="idx">
        <div class="empty_img">
          <img src="@/assets/images/activity-img.png" alt="" />
        </div>
        <div class="empty_over">本次集采活动已结束</div>
        <div class="empty_sale">源头厂家促销 敬请期待</div>
        <div>关注平台，实时获取最新集采信息</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPromotionList } from "@/api/shop";
import { debounce } from "@/utils/tools";
import { showPrice0 } from "@/enum/goods";
import CountDown from "@/components/shop/CountDown.vue";
export default {
  components: {
    CountDown,
  },
  mounted() {
    this.getPromotionList();
  },
  data() {
    return {
      list: [],
      suppleList: [],
      showPrice0,
      countDownNum: "",
    };
  },
  methods: {
    getComputed(item) {
      if (
        new Date(item.promotionStartTime).getTime() < Date.now() &&
        item.longTermEffective
      ) {
        return "长期";
      } else if (new Date(item.promotionEndTime).getTime() <= Date.now()) {
        return "已结束";
      }
    },
    isBegin(time) {
      return new Date(time).getTime() > Date.now();
    },
    getCertainTime(item) {
      if (new Date(item.promotionStartTime).getTime() > Date.now()) {
        return item.promotionStartTime;
      } else {
        return item.promotionEndTime;
      }
    },
    refreshPromotionList() {
      debounce(this.getPromotionList, 1000);
    },
    getPromotionList() {
      getPromotionList().then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.records || [];
          let index = this.list.length;
          if (index % 5 !== 0) {
            this.suppleList.length = 5 - (index % 5);
          }
        }
      });
    },
    jumpDetail(goodsId) {
      this.$router.push({
        name: "ActivityDetails",
        params: {
          goodsId,
        },
      });
    },
    format_with_array(number) {
      // 转为字符串，并按照.拆分
      const arr = (number + "").split(".");
      // 整数部分再拆分
      const int = arr[0].split("");
      // 小数部分
      const fraction = arr[1] || "";
      // 返回的变量
      let r = "";
      int.reverse().forEach(function (v, i) {
        // 非第一位并且是位值是3的倍数，添加“,”
        if (i !== 0 && i % 3 === 0) {
          r = v + "," + r;
        } else {
          // 正常添加字符(这是好写法)
          r = v + r;
        }
      });
      // 整数部分和小数部分拼接
      return r + (fraction ? "." + fraction : "");
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-menu {
  width: 1200px;
  margin: 0 auto;
}
.activity_area {
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  margin: 20px 0;
}
.activity {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.activity_over {
  width: 1200px;
  height: 200px;
  img {
    width: 100%;
    height: 100%;
  }
}
.empty {
  width: 232px;
  height: 300px;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 11px;
  margin-right: 9px;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
.empty:last-child {
  margin-right: 0px;
}
.empty_img {
  height: 134px;
  width: 183px;
  margin-top: 10px;
  margin-bottom: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.empty_over {
  font-weight: 500;
  font-size: 18px;
  color: #007eff;
  margin-bottom: 20px;
}
.empty_sale {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  margin-bottom: 20px;
}
.card-container {
  width: 232px;
  height: 300px;
  background-color: #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 11px;
  margin-right: 9px;
  cursor: pointer;
  .imgSrc {
    height: 120px;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .goods-amount {
    margin-top: 14px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .sale_price {
      font-weight: 400;
      font-size: 16px;
      color: #e60012;
      margin-right: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .origin_price {
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    text-decoration-line: line-through;
    margin-bottom: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .goods-name {
    width: 100%;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 14px;
  }
  .stock {
    margin: 14px 0;
    color: #999;
    font-size: 14px;
  }
}
.card-container:nth-of-type(5n) {
  margin-right: 0px;
}
</style>
